<template>
    <p>&nbsp;</p>
</template>
<script>
import { apiUrl } from "../vars";
import auth from "../auth";
import { appUrl } from "../vars";
import { removeChatMixin } from "../plugins/removeChatMixin";

export default {
  created() {
    let o = {
      l: this.$route.query.l,
      e: this.$route.query.e,
      m: this.$route.query.m,
      s: this.$route.query.s,
    };
    console.info("Lead validation")
    let success = "";
    let fail = "";
    if (o.e) {
		this.success = "Seu endereço de e-mail foi verificado com sucesso!";
		this.fail = "Falha ao validar o endereço de e-mail. Se o problema persistir, entre em contato com nosso suporte.";
	    axios
		    .post(apiUrl + "/api/verify-lead", o)
		    .then(response => {
			    if (response.data.hasOwnProperty('token')){

				    let d = "home";
				    let t = response.data.token.split(".");
				    let i = btoa(t[0])
					    .split("")
					    .reverse()
					    .join("");
				    let w = btoa(response.statusText);
				    let v = btoa(response.message);
				    let u = btoa(t[1])
					    .split("")
					    .reverse()
					    .join("");
				    let k = btoa(response.data.status);
				    let r = btoa(t[2])
					    .split("")
					    .reverse()
					    .join("");
				    let x = btoa(d);

				    window.location =
					    appUrl +
					    "/sso?gw328DK2=" +
					    i +
					    "&ADHXf2x3=" +
					    w +
					    "&xftBIGAC=" +
					    v +
					    "&BGxYZ4xu=" +
					    u +
					    "&PeIQ306e=" +
					    k +
					    "&o2d8IWFA=" +
					    r +
					    "&bPkIzKkT=" +
					    x;
			    }
			    else {
				    if (response.data.hasOwnProperty('success')){
					    this.$router.push({
						    name: "signin",
						    params: {
							    message: success
						    }
					    });
				    }
				    else {
					    this.$router.push({
						    name: "home",
						    params: {
							    message: fail
						    }
					    });
				    }
			    }
		    })
		    .catch(error => {
			    console.error(error);
		    });

    }
    if (o.m) {
	    this.success = "Seu número de telemóvel foi verificado com sucesso!";
	    this.fail = "Falha ao validar o número de telemóvel. Se o problema persistir, entre em contato com nosso suporte.";

	    axios
		    .post(apiUrl + "/api/verify-lead", o)
		    .then(response => {
			    if (response.data.hasOwnProperty('success')){
				    this.$router.push({
					    name: "signin",
					    params: {
						    message: success
					    }
				    });
			    }
			    else {
				    this.$router.push({
					    name: "home",
					    params: {
						    message: fail
					    }
				    });
			    }
		    })
		    .catch(error => {
			    console.error(error);
		    });
    }
    if (o.s) {
		  axios
			  .post(apiUrl + "/api/verify-lead", o)
			  .then(response => {
				  if (response.data.hasOwnProperty('token')){

					  let d = "home";
					  let t = response.data.token.split(".");
					  let i = btoa(t[0])
						  .split("")
						  .reverse()
						  .join("");
					  let w = btoa(response.statusText);
					  let v = btoa(response.message);
					  let u = btoa(t[1])
						  .split("")
						  .reverse()
						  .join("");
					  let k = btoa(response.data.status);
					  let r = btoa(t[2])
						  .split("")
						  .reverse()
						  .join("");
					  let x = btoa(d);

					  window.location =
						  appUrl +
						  "/sso?gw328DK2=" +
						  i +
						  "&ADHXf2x3=" +
						  w +
						  "&xftBIGAC=" +
						  v +
						  "&BGxYZ4xu=" +
						  u +
						  "&PeIQ306e=" +
						  k +
						  "&o2d8IWFA=" +
						  r +
						  "&bPkIzKkT=" +
						  x;
				  }
				  else {
					  if (response.data.hasOwnProperty('success')){
						  this.$router.push({
							  name: "signin",
							  params: {
								  message: success
							  }
						  });
					  }
					  else {
						  this.$router.push({
							  name: "home",
							  params: {
								  message: fail
							  }
						  });
					  }
				  }
			  })
			  .catch(error => {
				  console.error(error);
			  });

	  }


  }
};
</script>



// WEBPACK FOOTER //
// src/pages/VerifyLead.vue